/* eslint-disable no-case-declarations */
import { cloneDeep } from 'lodash';
import type from './BOMConfig.type';

const initialState = {
  tabs: [],
  tabsData: [],
  commentsStatus: false,
  commentsText: '',
  devOrders: [],
  productSuggestion: [],
  librarySuggestion: [],
  groupSuggestion: [],
  cardList: [],
  comment: '',
  commentSwitch: false,
  isVisibleToSupplier: [],
  productDetails: {},
  isProductArchived: false,
  trafficLights: [],
  totalCardList: 0,
  selectedTab: null,
  suppliers: [],
  tagsData: [],
  tagsList: [],
  tagsListById: [],
};

const BOMConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.NEW_CONFIG_TABS:
      const selectedTabs = action?.payload?.length ? action.payload : [];
      console.log('🚀 ~ file: BOMConfig.reducer.js:32 ~ BOMConfigReducer ~ selectedTabs:', selectedTabs);
      return {
        ...state,
        tabs: selectedTabs,
      };
    case type.DEFAULT_CONFIG_TABS:
      let collectedTabs = [];
      const Tabs = action?.payload?.length ? action.payload : [];
      Tabs?.forEach((element) => {
        state?.tabsData?.forEach((ele) => {
          if (ele._id === element._id) {
            element.status = ele?.value;
            element.switch = ele?.value;
          }
        });
      });
      collectedTabs = [...Tabs];

      return {
        ...state,
        tabs: collectedTabs,
      };

    case type.TOOGLE_CONFIG_COMMENTS:
      return {
        ...state,
        commentsStatus: action.payload,
      };
    case type.FETCH_DEV_ORDER:
      return {
        ...state,
        devOrders: action?.payload?.length > 0 ? action.payload : [],
      };
    case type.FETCH_PRODUCT_SUGGESTION:
      return {
        ...state,
        productSuggestion: action?.payload?.length > 0 ? action.payload : [],
      };
    case type.FETCH_LIBRARY_SUGGESTION:
      return {
        ...state,
        librarySuggestion: action?.payload?.length > 0 ? action.payload : [],
      };
    case type.FETCH_GROUP_SUGGESTION:
      return {
        ...state,
        groupSuggestion: action?.payload?.length > 0 ? action.payload : [],
      };
    case type.BOM_SUPPLIER:
      const bomSuppliers = [];
      if (action?.payload?.length) {
        bomSuppliers.push(...action.payload);
      }
      return {
        ...state,
        suppliers: bomSuppliers,
      };
    case type.FETCH_CARD_LIST:
      return {
        ...state,
        cardList: action.payload.doc,
        totalCardList: action.payload.totalCount,
      };
    case type.ADD_CARD_LIST:
      const oldCard = cloneDeep(state.cardList);
      const newCard = action?.payload || [];
      const updateCard = Array.isArray(newCard) ? [...newCard, ...oldCard] : [...oldCard];
      let count = state.totalCardList;
      count += newCard.length;
      return {
        ...state,
        cardList: updateCard,
        totalCardList: count,
      };
    case type.CONFIG_COMMENTS:
      return {
        ...state,
        commentsText: action.payload,
      };

    case type.FETCH_PRODUCT_DETAILS:
      return {
        ...state,
        productDetails: action.payload,
        isProductArchived: action.payload.isArchived || action.payload.isDeleted,
      };

    case type.FETCH_TRAFFIC_LIGHTS:
      return {
        ...state,
        trafficLights: action.payload,
      };

    case type.ADD_CARD_LIST_BY_PAGINATION:
      const oldCardList = JSON.parse(JSON.stringify(state.cardList));
      const newCardListDetails = action?.payload?.doc ? action.payload.doc : [];
      const updateCardList = [...oldCardList, ...newCardListDetails];
      const number = action?.payload?.totalCount ? action.payload.totalCount : 0;
      return {
        ...state,
        cardList: updateCardList,
        totalCardList: number,
      };

    case type.FETCH_ORDER_PERMISSION:
      let updateData = JSON.parse(JSON.stringify(state));
      if (action.payload && Object.keys(action.payload).length > 0) {
        const comment = action.payload.comment ? action.payload.comment : '';
        const visibleToSupplier = action.payload.bomSwitches ? action.payload.bomSwitches : [];
        console.log('🚀 ~ file: BOMConfig.reducer.js:154 ~ BOMConfigReducer ~ visibleToSupplier:', visibleToSupplier);
        const commentSwitch = action?.payload?.isVisibleToSupplier?.comment ? action.payload.isVisibleToSupplier.comment : false;
        updateData = {
          ...state,
          comment,
          isVisibleToSupplier: visibleToSupplier,
          commentSwitch,
          tabsData: action.payload.bomSwitches,
        };
      }
      return { ...updateData };

    case type.UPDATE_BOM_SWITCHES:
      return {
        ...state,
        isVisibleToSupplier: action.payload,
      };
    case type.UNMOUNT_COMPONENT:
      return {
        ...state,
        ...initialState,
      };

    case type.TAB_SELECTION:
      const tabId = action.payload;
      const OldTabs = JSON.parse(JSON.stringify(state.tabs));
      const filtertedTab = OldTabs.filter((item) => item._id === tabId);
      return {
        ...state,
        selectedTab: filtertedTab.length > 0 ? filtertedTab[0] : null,
        devOrders: [],
        productSuggestion: [],
        librarySuggestion: [],
        groupSuggestion: [],
        // cardList: []
      };
    case type.BOM_UNMOUNT:
      return {
        ...state,
        productDetails: {},
      };
    case type.ADD_BOM_TAG:
      return {
        ...state,
        tagsData: action?.payload?.length ? action.payload : [],
      };
    case type.GET_BOM_TAG:
      return {
        ...state,
        tagsList: action?.payload?.length ? action.payload : [],
      };
    case type.GET_BOM_BYID:
      return {
        ...state,
        tagsListById: action?.payload?.length ? action.payload : [],
      };
    case type.CLEAR_BOM_REDUCER:
      return {
        ...state,
        commentsStatus: false,
        commentsText: '',
        comment: '',
        commentSwitch: false,
      };
    case type.CLEAR_BOM_CARDLIST:
      return {
        ...state,
        cardList: [],
      };
    default:
      return state;
  }
};

export default BOMConfigReducer;
